import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { SeoService } from '../services/seo.service';

@Injectable({ providedIn: 'root' })
export class SeoGuard implements CanActivate {
  constructor(private seo: SeoService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    console.log('SeoGuard: Prüfe Zugriff auf Route', state.url);
    const data = route.data;
    const fallbackTitle = $localize`AlbCode - Software & Webentwicklung Saliger`;

    this.seo.setTitle(data['title'] || fallbackTitle);
    this.seo.setDescription(data['desc']);
    if (data['keywords']) {
      this.seo.setKeywords(data['keywords']);
    }
    this.seo.setImage(data['image']);

    this.seo.setCanonicalUrl(state.url);

    return true;
  }
}
